// components/common/CardHeader.jsx
import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import SmartParameter from "./SmartParameter";

function CardHeader({
  title,
  subtitle,
  showHelpIcon = true,
  helpReference = "",
  helpText = "",
  helpLink = "",
  fieldName = "",
  touched = {},
  errors = {},
  iconColor = "black",
  titleVariant = "h5",
  subtitleVariant = "contentMiddle",
  backgroundColor = "#C8C8C8",
  ...boxProps
}) {
  return (
    <Box
      sx={{
        pb: "10px",
        px: 2,
        mb: 2,
        backgroundColor,
        borderRadius: "10px 10px 0px 0px",
      }}
      display="block"
      align="center"
      {...boxProps}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.5,
          mt: "14px",
        }}
      >
        <Typography sx={{whiteSpace: "pre-line"}} variant={titleVariant} color="black" fontWeight={600}>
          {title}
        </Typography>

        {showHelpIcon && (
          <SmartParameter
            value=""
            helpReference={helpReference}
            helpText={helpText}
            helpLink={helpLink}
            fieldName={fieldName}
            iconColor={iconColor}
            touched={touched}
            errors={errors}
          />
        )}
      </Box>

      {subtitle && (
        <Typography
          fontWeight={400}
          color="black"
          variant={subtitleVariant}
          sx={{
            whiteSpace: "pre-line",
            wordBreak: "break-all",
            overflowWrap: "break-word",
            hyphens: "auto",
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}

CardHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  showHelpIcon: PropTypes.bool,
  helpReference: PropTypes.string,
  helpText: PropTypes.string,
  helpLink: PropTypes.string,
  fieldName: PropTypes.string,
  touched: PropTypes.object,
  errors: PropTypes.object,
  iconColor: PropTypes.string,
  titleVariant: PropTypes.string,
  subtitleVariant: PropTypes.string,
  backgroundColor: PropTypes.string,
};

export default CardHeader;
